import { MutationTree } from 'vuex';
import { IState, IItem } from './state';
import { ActionPayload } from './actions';

type MutationHandler<PayloadType> = (state: IState, payload: ActionPayload<PayloadType>) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, payload);
	state.initialNumberToShow = payload.numberToShow;
}

const setItemsMutation: MutationHandler<IItem[]> = (state, { payload }) => {
	state.items = payload
}

const setTotalMutation: MutationHandler<number> = (state, { payload }) => {
	state.total = payload
}

const setNumberToShowMutation: MutationHandler<number> = (state, { payload }) => {
	state.numberToShow = payload;
}

const setLoadingMutation: MutationHandler<boolean> = (state, { payload }) => {
	state.loading = payload
}

const mutations: MutationTree<IState> = {
	setState: setStateMutation,
	setItems: setItemsMutation,
	setLoading: setLoadingMutation,
	setTotal: setTotalMutation,
	setNumberToShow: setNumberToShowMutation,
}

export default mutations
